export default [{
	titulo: 'Galerias',
	icone: 'menu-icon fa fa-caret-right',
	url: '/site/galerias',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]